import { Col, Row } from 'antd';
import React from 'react';

interface Props {
  name: string;
  paymentName: string;
}

const PaymentDetailsHeaderComponent: React.FC<Props> = ({ name, paymentName }) => {
  return (
    <Row style={{ backgroundColor: '#ddd', marginBottom: 10 }}>
      <Col style={{ padding: 10 }} xs={12}>
        <strong>Bezorger</strong> <br /> {name}
      </Col>
      <Col style={{ padding: 10 }} xs={6}>
        <strong>Via</strong> <br />
        {paymentName}
      </Col>
    </Row>
  );
};

export { PaymentDetailsHeaderComponent };
